/**
 * Version utilities for the Chatable Web App
 */

import { createLogger } from "./logger";

const logger = createLogger("Version");

// Get commit SHA from Vite environment variable
export const COMMIT_SHA = import.meta.env.VITE_COMMIT_SHA || "dev";

// Get app version from package.json
export const APP_VERSION = import.meta.env.VITE_APP_VERSION || "0.0.0";

/**
 * Log version information to console
 */
export function logVersionInfo(): void {
  logger.info(`Chatable Web App - Version: ${COMMIT_SHA}`, {
    commitSha: COMMIT_SHA,
    appVersion: APP_VERSION,
  });

  // Additional info in development
  logger.debug("Development environment details", {
    mode: "development",
    appVersion: APP_VERSION,
    apiBaseUrl: import.meta.env.VITE_API_BASE_URL,
  });
}

/**
 * Get version info as an object
 */
export function getVersionInfo() {
  return {
    commitSha: COMMIT_SHA,
    appVersion: APP_VERSION,
    buildTime: import.meta.env.VITE_BUILD_TIME || "unknown",
    environment: import.meta.env.MODE,
  };
}
